import React from 'react';

// Hooks
import { useIntl } from 'react-intl';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { useLocation } from 'react-router-dom';

// Styles
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import styles from './SurveyCard.style';

// Utils
import messages from 'src/shared/app/nav/l10n/navigationL10n.json';
import {
  signupRoute,
  loginRoute,
  loginSupportRoute,
  retrieveUsernameRoute,
  loginLinkRoute,
  passwordSupportRoute,
  resetPasswordRoute,
} from 'src/shared/app/base/route/setting/routeSettings';

// Components
import SidebarCard from 'src/shared/app/base/component/template/component/sidebar/SidebarCard';
import ChevronIcon from 'src/shared/ui/component/icon/ChevronIcon';

// Assets
import designImg from 'src/shared/app/base/assets/images/prodideFeedback.png';
import { getStaticAsset } from 'src/shared/app/base/util/assetUtils';

const useStyles = createUseThemeStyles(styles);

const surveyLink = 'https://braindate.nolt.io/';

type Props = {
  showSurvey?: boolean,
};

const SurveyCard = ({ showSurvey }: Props) => {
  const classes = useStyles();
  const intl = useIntl();
  const { pathname } = useLocation();

  const routesThatShouldBeHidden = useRoutes(
    signupRoute,
    loginRoute,
    loginSupportRoute,
    retrieveUsernameRoute,
    loginLinkRoute,
    passwordSupportRoute,
    resetPasswordRoute,
  );

  const shouldBeHidden = routesThatShouldBeHidden.includes(pathname);

  if (!showSurvey || shouldBeHidden) {
    return null;
  }

  return (
    <SidebarCard title={intl.formatMessage(messages.provideFeedback)}>
      <div className={classes.root}>
        <img className={classes.img} src={getStaticAsset(designImg)} alt="" />

        <span className={classes.text}>
          {intl.formatMessage(messages.doBetter)}
        </span>

        <a
          href={surveyLink}
          target="_blank"
          rel="noreferrer"
          className={classes.link}
        >
          {intl.formatMessage(messages.share)}
          <ChevronIcon className={classes.linkChevron} />
        </a>
      </div>
    </SidebarCard>
  );
};

export default SurveyCard;
